// extracted by mini-css-extract-plugin
module.exports = {"dark":"i_I","light":"i_J","container":"i_K","major":"i_L","loading":"i_M","fluid":"i_N","body":"i_O","elastic":"i_P","icon":"i_Q","label":"i_R"};